import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Store } from '@/shared/store';
import {
    getUserBorrowsClosedAction,
    getUserBorrowsOpenedAction,
    getUserBorrowsRegisteredAction,
    getUserBorrowsSuspendedAction,
} from '@/shared/store/borrows/actions';
import { BorrowStatusType } from '@/shared/api/borrow';

const PULL_INTERVAL = 5000;

export const useFetchUserBorrows = (selectedBorrowStatusList: BorrowStatusType) => {
    const dispatch = useDispatch();
    const {
        walletAddress,
        userBorrowsOpenedLoading,
        userBorrowsSuspendedLoading,
        userBorrowsRegisteredLoading,
        userBorrowsClosedLoading,
    } = useSelector((state: Store) => ({
        walletAddress: state.wallets.active?.address,
        userBorrowsOpenedLoading: state.borrows.userBorrowsOpenedLoading,
        userBorrowsSuspendedLoading: state.borrows.userBorrowsSuspendedLoading,
        userBorrowsRegisteredLoading: state.borrows.userBorrowsRegisteredLoading,
        userBorrowsClosedLoading: state.borrows.userBorrowsClosedLoading,
    }));

    const callUserBorrows = useCallback(() => {
        if (!walletAddress) return;

        switch (selectedBorrowStatusList) {
            case BorrowStatusType.OPENED:
                if (!userBorrowsOpenedLoading) dispatch(getUserBorrowsOpenedAction());
                break;
            case BorrowStatusType.SUSPENDED:
                if (!userBorrowsSuspendedLoading) dispatch(getUserBorrowsSuspendedAction());
                if (!userBorrowsRegisteredLoading) dispatch(getUserBorrowsRegisteredAction());
                break;
            case BorrowStatusType.CLOSED:
                if (!userBorrowsClosedLoading) dispatch(getUserBorrowsClosedAction());
                break;
        }
    }, [walletAddress, selectedBorrowStatusList]);

    useEffect(() => {
        callUserBorrows();
        const interval = setInterval(callUserBorrows, PULL_INTERVAL);
        return () => clearInterval(interval);
    }, [callUserBorrows]);

    return { callUserBorrows };
};
